<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">
            <router-link :to="{name: 'SubscriptionList'}" class="subtitle-1 routerLink font-weight-medium">Suscripciones</router-link>
            <v-icon class="mx-1" color="secondary">mdi-chevron-right</v-icon>
            <span class="subtitle-1 font-weight-medium">Nueva suscripción</span>
          </v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text class="py-0 background">
          <!-- customer -->
          <v-row justify="space-between">
            <v-col cols="12" class="text-center py-5" v-if="!subscription.customer">
              <v-icon class="d-block" color="secondary" size="70">mdi-account</v-icon>
              <span class="d-block subtitle-1">Selecciona un cliente para continuar</span>
              <v-btn class="my-5" @click="dialogCustomer=true" outlined color="secondary">Seleccionar un cliente</v-btn>
            </v-col>
            <v-col cols="6" v-else>
              <v-toolbar color="transparent" flat height="48">
                <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Cliente</v-toolbar-title>
              </v-toolbar>
              <v-divider />
              <v-list class="transparent" two-line>
                <v-list-item>
                  <v-menu open-on-hover bottom offset-y :nudge-bottom="15" :close-delay="100" transition="slide-y-transition">
                    <template v-slot:activator="{ on }">
                      <v-list-item-content v-on="on">
                        <v-list-item-title class="subtitle-2 text--secondary font-weight-medium">{{activeCustomer.name}}</v-list-item-title>
                        <v-list-item-subtitle class="text--primary">{{activeCurrency.id}} - {{activeCurrency.name}}</v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                    <v-card>
                      <v-card-text>
                        <v-list class="v-list-form transparent">
                          <v-list-item class="px-0">
                            <v-list-item-title>ID Fiscal</v-list-item-title>
                            <v-list-item-subtitle v-if="activeCustomer.tax_id">{{activeCustomer.tax_id}}</v-list-item-subtitle>
                            <v-list-item-subtitle class="text--disabled font-italic" v-else>Sin ID Fiscal</v-list-item-subtitle>
                          </v-list-item>
                          <v-list-item class="px-0">
                            <v-list-item-title>Dirección</v-list-item-title>
                            <v-list-item-subtitle>{{activeCustomer.address}}</v-list-item-subtitle>
                          </v-list-item>
                          <v-list-item class="px-0">
                            <v-list-item-title>Estado</v-list-item-title>
                            <v-list-item-subtitle>{{activeCustomer.state.name}}</v-list-item-subtitle>
                          </v-list-item>
                          <v-list-item class="px-0">
                            <v-list-item-title>País</v-list-item-title>
                            <v-list-item-subtitle>{{activeCustomer.country.name}}</v-list-item-subtitle>
                          </v-list-item>
                          <v-list-item class="px-0">
                            <v-list-item-title>Email</v-list-item-title>
                            <v-list-item-subtitle>{{activeCustomer.email}}</v-list-item-subtitle>
                          </v-list-item>
                          <v-list-item class="px-0">
                            <v-list-item-title>Teléfono</v-list-item-title>
                            <v-list-item-subtitle v-if="activeCustomer.phone">{{activeCustomer.phone}}</v-list-item-subtitle>
                            <v-list-item-subtitle class="text--disabled font-italic" v-else>Sin teléfono</v-list-item-subtitle>
                          </v-list-item>
                        </v-list>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                  <v-list-item-action>
                    <v-btn @click="dialogCustomer=true" outlined color="secondary">Cambiar...</v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
              <v-divider />
            </v-col>
          </v-row>
          <!-- end customer -->

          <!-- subscription lines -->
          <template v-if="subscription.customer">
            <v-toolbar color="transparent" flat height="55">
              <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Productos</v-toolbar-title>
            </v-toolbar>
            <v-divider/>
            <!-- products -->
            <template v-if="subscription.lines.length">
              <v-simple-table class="v-sm-text-fields transparent" dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th style="min-width:220px">Plan de precios</th>
                      <th style="min-width:220px"></th>
                      <th class="text-right" style="width:150px;">Cantidad</th>
                      <th class="text-right" style="width:100px;"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(d, i) in subscription.lines" :key="d.id">
                      <td>
                        <v-row align="center" justify="space-between" no-gutters>
                          <v-col>
                            <span class="body-2 text--secondary font-weight-medium">{{d.plan.name}}</span>
                            <span class="d-block">
                              <template v-if="d.plan.tiers_mode">desde {{d.plan.tiers[0].amount | currency(d.plan.currency.id)}}</template>
                              <template v-else>{{d.plan.amount | currency(d.plan.currency.id)}}</template>
                              {{d.plan.currency.id}} {{d.plan.frequency.name.toLowerCase()}}
                            </span>
                          </v-col>
                          <v-col v-if="d.plan.tiers.length">
                            <v-tooltip v-if="d.plan.tiers.length" content-class="pa-0 overflow-hidden" max-width="420px" right transition="scale-transition">
                              <template v-slot:activator="{ on }">
                                <v-icon class="ml-2" v-on="on" small color="secondary">mdi-chart-gantt</v-icon>
                              </template>
                              <tier-list :tiers="d.plan.tiers" :currency="d.plan.currency.id" :tiers-mode="d.plan.tiers_mode" />
                            </v-tooltip>
                          </v-col>
                        </v-row>
                      </td>
                      <td>
                        <v-row no-gutters align="center" justify="space-between">
                          <v-col cols="10" v-if="d.coupon">
                            <span class="d-block body-2 text--secondary font-weight-medium">{{d.coupon.name}}</span>

                            <!-- line discount amount -->
                            <span v-if="d.coupon.discount_scheme === '%'" class="mr-1">{{d.coupon.amount | number(false)}} %</span>
                            <span v-else-if="d.coupon.discount_scheme === '$'" class="mr-1">{{d.coupon.amount | number(d.coupon.currency.rounded)}} {{d.coupon.currency.id}}</span>
                            <!-- end line discount amount -->

                            <!-- line discount duration -->
                            <span v-if="d.coupon.duration_scheme === 'one_time'" class="mr-1">por 1 ciclo de facturación</span>
                            <span v-else-if="d.coupon.duration_scheme === 'forever'" class="mr-1">por siempre</span>
                            <span v-else-if="d.coupon.duration_scheme === 'limited'" class="mr-1">por {{d.coupon.duration_times}} ciclos de facturación</span>
                            <!-- end line discount duration -->
                          </v-col>
                          <v-col cols="2">
                            <v-menu v-if="d.coupon" close-on-click close-on-content-click offset-y :nudge-bottom="10" transition="slide-y-transition">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn v-bind="attrs" v-on="on" min-width="34" max-width="34" outlined color="secondary" :ripple="false" retain-focus-on-click><v-icon color="secondary">mdi-dots-horizontal</v-icon></v-btn>
                              </template>
                              <v-list class="pa-0">
                                <v-list-item class="px-5 py-1" @click="showModalCoupon('line', i)" :ripple="false">
                                  <v-list-item-title class="subtitle-2 text--secondary font-weight-medium">Seleccionar otro...</v-list-item-title>
                                </v-list-item>
                                <v-list-item class="px-5 py-1" @click="subscription.lines[i].coupon=null" :ripple="false">
                                  <v-list-item-title class="subtitle-2 red--text font-weight-medium">Quitar descuento</v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                            <v-btn text color="primary" v-ripple="false" @click="showModalCoupon('line', i)" v-else>Agregar cupón</v-btn>
                          </v-col>
                        </v-row>
                      </td>
                      <td>
                        <v-col class="px-0" v-if="d.plan.usage_scheme === 'licensed'">
                          <v-text-field v-model="$v.subscription.lines.$each[i].quantity.$model" background-color="white" height="16" reverse outlined required single-line dense hide-details />
                        </v-col>
                        <span v-else-if="d.plan.usage_scheme === 'metered'">
                          Variable
                          <v-tooltip top max-width="280px" transition="scale-transition">
                            <template v-slot:activator="{ on }">
                              <v-icon v-on="on" small color="secondary">mdi-timelapse</v-icon>
                            </template>
                            <span>A los clientes suscritos a este plan se les facturará de acuerdo al consumo registrado para el periodo de facturación.</span>
                          </v-tooltip>
                        </span>
                      </td>
                      <td class="text-right">
                        <v-btn @click="subscription.lines.splice(i, 1)" min-width="20" max-width="20" min-height="28" max-height="28" text color="red" :ripple="false"><v-icon size="20">mdi-delete</v-icon></v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-divider/>
              <v-row>
                <v-col class="py-4 text-center">
                  <v-btn @click="dialogProducts=true" outlined color="secondary"><v-icon left>mdi-plus</v-icon>Agregar un producto</v-btn>
                </v-col>
              </v-row>
            </template>
            <!-- end products -->
            <!-- empty products -->
            <v-row v-else>
              <v-col cols="12" class="text-center py-5">
                <v-icon class="d-block" color="secondary" size="48">mdi-cube</v-icon>
                <span class="d-block subtitle-1">Agrega un producto para continuar</span>
                <v-btn class="my-4" @click="dialogProducts=true" outlined color="secondary"><v-icon left>mdi-plus</v-icon>Agregar un producto</v-btn>
              </v-col>
            </v-row>
          </template>
          <!-- end empty products -->

          <template v-if="subscription.lines.length">
            <v-toolbar color="transparent" flat height="55">
              <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Complementos<v-chip class="ml-3" color="secondary" x-small>Opcional</v-chip></v-toolbar-title>
            </v-toolbar>
            <v-divider/>
            <!-- addons -->
            <template v-if="subscription.addons.length">
              <v-simple-table class="v-sm-text-fields transparent" dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>Complemento</th>
                      <th></th>
                      <th class="text-right" style="width:120px">Cantidad</th>
                      <th class="text-right" style="width:120px">Total</th>
                      <th style="width:100px"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(d, i) in subscription.addons">
                      <tr :key="i">
                        <td class="py-3">
                          <span class="body-2 text--secondary font-weight-medium">{{d.addon.name}}</span>
                          <div>
                            <span>{{d.addon.amount | number(d.addon.currency.rounded)}} {{d.addon.currency.id}} / {{d.addon.apply_scheme === 'recurring' ? 'Recurrente' : 'Una vez'}}</span>
                            <span v-if="d.addon.apply_scheme === 'recurring'">válido por {{d.addon.duration_times}} ciclos de facturación</span>
                          </div>
                        </td>
                        <td>
                          <template v-if="d.addon.apply_scheme === 'one_time'">
                            <v-row align="center" justify="start" class="mx-0">
                              <span class="text--secondary font-weight-medium">Facturación prorrateada</span>
                              <v-switch @change="$event ? setAddonLineRate(i) : subscription.addons[i].rates=[]" class="ml-3"/>
                            </v-row>
                          </template>
                        </td>
                        <td class="text-right px-0">
                          <v-text-field v-model="$v.subscription.addons.$each[i].quantity.$model" background-color="white" height="16" reverse outlined required single-line dense hide-details />
                        </td>
                        <td class="text-right">
                          <span class="text--secondary font-weight-medium">{{(d.addon.amount * d.quantity) | number(d.addon.currency.rounded)}}</span> <span class="body-2">{{d.addon.currency.id}}</span>
                        </td>
                        <td class="text-right">
                          <v-btn @click="subscription.addons.splice(i, 1)" min-width="20" max-width="20" min-height="28" max-height="28" text color="red" :ripple="false"><v-icon size="20">mdi-delete</v-icon></v-btn>
                        </td>
                      </tr>
                      <tr class="rules" :key="`${i}-rates`" v-if="d.addon.apply_scheme === 'one_time' && d.rates.length">
                        <td colspan="5" class="py-5">
                          <span class="body-1 text--secondary font-weight-medium">Prorrateo del complemento</span>
                          <v-col class="pa-0">
                            <div v-for="(r, ri) in d.rates" :key="ri" class="mt-4">
                              <div class="d-flex">
                                <v-row class="background text--secondary mx-2 ml-0" style="border-radius: 4px; max-width: 120px; height: 40px;" align="center" no-gutters justify="center">en el periodo</v-row>
                                <div class="mx-2" style="width:100px">
                                  <v-text-field v-model.number="$v.subscription.addons.$each[i].rates.$each[ri].billing_cycle.$model" :error="$v.subscription.addons.$each[i].rates.$each[ri].billing_cycle.$error" background-color="white" height="16" outlined required single-line dense hide-details/>
                                </div>
                                <v-row class="background text--secondary mx-2" style="border-radius: 4px; max-width: 100px; height: 40px;" align="center" no-gutters justify="center">facturar el</v-row>
                                <div class="mx-2" style="width:100px">
                                  <v-text-field v-model.number="$v.subscription.addons.$each[i].rates.$each[ri].percentage.$model" :error="$v.subscription.addons.$each[i].rates.$each[ri].billing_cycle.$error" suffix="%" background-color="white" height="16" outlined required single-line dense hide-details placeholder="0"/>
                                </div>
                                <v-row class="background text--secondary mx-2" style="border-radius: 4px; max-width: 180px; height: 40px;" align="center" no-gutters justify="center">con la descripción</v-row>
                                <div class="mx-2" style="width:350px">
                                  <v-text-field v-model.trim="$v.subscription.addons.$each[i].rates.$each[ri].description.$model" :error="$v.subscription.addons.$each[i].rates.$each[ri].billing_cycle.$error" background-color="white" height="16" outlined required single-line dense hide-details />
                                </div>
                                <div class="mx-2" style="width:40px">
                                  <v-btn v-if="ri > 1" @click="subscription.addons[i].rates.splice(ri, 1)" min-width="20" max-width="20" min-height="28" max-height="28" text color="red" :ripple="false"><v-icon size="20">mdi-delete</v-icon></v-btn>
                                </div>
                              </div>
                            </div>
                          </v-col>
                          <v-col class="pa-0 mt-4">
                            <v-btn text color="primary" :ripple="false" @click="addAddonLineRate(i)" :disabled="subscription.addons[i].rates.length > 5"><v-icon left>mdi-plus</v-icon>Agregar cuota</v-btn>
                            <span v-if="$v.subscription.addons.$each[i].rates.$error" class="ml-5 red--text">Algunas reglas contienen error. Corrige los campos marcados.</span>
                          </v-col>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </template>
              </v-simple-table>
              <v-divider/>
              <v-row class="py-4">
                <v-col class="text-center">
                  <v-btn @click="modalAddons=true" outlined color="secondary"><v-icon left>mdi-plus</v-icon>Agregar un complemento</v-btn>
                </v-col>
              </v-row>
            </template>
            <!-- end addons -->
            <!-- addons empty -->
            <v-row v-else>
              <v-col cols="12" class="text-center py-5">
                <v-icon class="d-block" color="secondary" size="48">mdi-cube</v-icon>
                <v-btn class="my-4" @click="modalAddons=true" outlined color="secondary"><v-icon left>mdi-plus</v-icon>Agregar un complemento</v-btn>
              </v-col>
            </v-row>
            <!-- end addons empty -->

            <!-- workflow -->
            <v-toolbar color="transparent" flat height="55">
              <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Workflow</v-toolbar-title>
            </v-toolbar>
            <v-divider/>
            <v-row class="pt-2 pb-6">
              <v-col md="8">
                <v-list class="transparent">
                  <v-list-item dense>
                    <v-list-item-content>
                      <v-list-item-title class="mb-2 body-2 text--secondary font-weight-medium">¿Qué se debe hacer primero?</v-list-item-title>
                      <v-radio-group class="my-0" v-model="subscription.collection_scheme" hide-details>
                        <v-radio value="charge_payment" :readonly="!activeCustomer.sources.length">
                          <template v-slot:label>
                            <!-- if don't meet conditions -->
                            <v-tooltip v-if="!activeCustomer.sources.length" right transition="scale-transition">
                              <template v-slot:activator="{ on }">
                                <span v-on="on" class="text--disabled">Procesar el pago</span>
                              </template>
                              <span>No disponible. El cliente debe tener una tarjeta registrada.</span>
                            </v-tooltip>
                            <!-- if don't meet conditions -->
                            <span v-else>Procesar el pago</span>
                            <v-btn class="ml-2" text color="primary" :ripple="false">Ver workflow<v-icon right small>mdi-open-in-new</v-icon></v-btn>
                          </template>
                        </v-radio>
                        <v-radio value="send_invoice">
                          <template v-slot:label>
                            <span>Crear la factura</span>
                            <v-btn class="ml-2" text color="primary" :ripple="false">Ver workflow<v-icon right small>mdi-open-in-new</v-icon></v-btn>
                          </template>
                        </v-radio>
                      </v-radio-group>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
            <!-- end workflow -->

            <!-- payment method -->
            <v-toolbar color="transparent" flat height="55">
              <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Método de pago</v-toolbar-title>
            </v-toolbar>
            <v-divider/>
            <v-row class="pt-2 pb-6">
              <v-col md="8">
                <v-list class="v-list-form v-sm-text-fields transparent" v-if="sourcesList.length">
                  <v-list-item>
                    <v-list-item-title class="body-2 text--secondary">Cargar a la tarjeta del cliente</v-list-item-title>
                    <v-list-item-subtitle class="py-1">
                      <v-col cols="8">
                        <v-select v-model="subscription.default_source" :items="sourcesList" item-value="id" :menu-props="{ overflowY: true, transition: 'slide-y-transition' }" height="36" background-color="white" solo flat single-line outlined dense hide-details :ripple="false">
                          <template v-slot:item="data">
                            <v-row align="center" dense>
                              <card-brand :brand="data.item.card.brand" />
                              <span class="ml-2 body-2 text--secondary">•••• •••• •••• {{data.item.card.last4}}</span>
                            </v-row>
                          </template>
                          <template v-slot:selection="data">
                            <v-row align="center" justify="space-between">
                              <card-brand class="ml-4" :brand="data.item.card.brand" />
                              <span class="ml-2 body-2 text--secondary">•••• •••• •••• {{data.item.card.last4}}</span>
                            </v-row>
                          </template>
                        </v-select>
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item>
                </v-list>
                <v-list class="transparent" v-else>
                  <v-list-item dense>
                    <v-list-item-title class="body-2 text--secondary">Enviar la factura al cliente junto a un enlace al portal de pagos para que realice el pago manualmente</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
            <!-- end payment method -->

            <!-- discount -->
            <v-toolbar color="transparent" flat height="55">
              <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Descuento al subtotal de la suscripción<v-chip class="ml-3" color="secondary" x-small>Opcional</v-chip></v-toolbar-title>
            </v-toolbar>
            <v-divider/>
            <v-row class="pt-2 pb-6">
              <v-col md="8">
                <v-list class="transparent">
                  <v-list-item>
                    <v-list-item-title>
                      <v-row align="center" justify="space-between">
                        <v-col class="px-3" v-if="subscription.coupon">
                          <span class="d-block body-2 text--secondary font-weight-medium">{{subscription.coupon.name}}</span>
                          <!-- subscription discount amount -->
                          <span v-if="subscription.coupon.discount_scheme === '%'" class="mr-1">{{subscription.coupon.amount | number(false)}} %</span>
                          <span v-else-if="subscription.coupon.discount_scheme === '$'" class="mr-1">{{subscription.coupon.amount | number(subscription.coupon.currency.rounded)}} {{subscription.coupon.currency.id}}</span>
                          <!-- end subscription discount amount -->

                          <!-- subscription discount duration -->
                          <span v-if="subscription.coupon.duration_scheme === 'one_time'" class="mr-1">por 1 ciclo de facturación</span>
                          <span v-else-if="subscription.coupon.duration_scheme === 'forever'" class="mr-1">por siempre</span>
                          <span v-else-if="subscription.coupon.duration_scheme === 'limited'" class="mr-1">por {{subscription.coupon.duration_times}} ciclos de facturación</span>
                          <!-- end subscription discount duration -->
                        </v-col>
                        <v-col class="px-3">
                          <v-menu v-if="subscription.coupon" close-on-click close-on-content-click offset-y :nudge-bottom="10" transition="slide-y-transition">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-bind="attrs" v-on="on" min-width="34" max-width="34" outlined color="secondary" :ripple="false" retain-focus-on-click><v-icon color="secondary">mdi-dots-horizontal</v-icon></v-btn>
                            </template>
                            <v-list class="pa-0">
                              <v-list-item class="px-5 py-1" @click="showModalCoupon('invoice')" :ripple="false">
                                <v-list-item-title class="subtitle-2 text--secondary font-weight-medium">Seleccionar otro...</v-list-item-title>
                              </v-list-item>
                              <v-list-item class="px-5 py-1" @click="subscription.coupon=null" :ripple="false">
                                <v-list-item-title class="subtitle-2 red--text font-weight-medium">Quitar descuento</v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                          <v-btn @click="showModalCoupon('invoice')" text color="primary" :ripple="false" v-else>Agregar cupón</v-btn>
                        </v-col>
                      </v-row>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
            <!-- end discount -->

            <!-- calendar -->
            <v-toolbar color="transparent" flat height="55">
              <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Calendario</v-toolbar-title>
            </v-toolbar>
            <v-divider/>
            <v-row class="py-2">
              <v-col md="2" class="pl-6">
                <v-list-item-title class="ml-1 font-weight-medium">Inicio</v-list-item-title>
                <v-menu v-model="menuDateStart" :close-on-content-click="false" offset-y :nudge-bottom="10" transition="slide-y-transition">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="$v.subscription.date_start.$model" :error="$v.subscription.date_start.$error" v-bind="attrs" v-on="on" background-color="white" height="36" outlined single-line dense readonly hide-details>
                      <template v-slot:append>
                        <v-icon class="mr-3" small color="secondary">mdi-calendar</v-icon>
                      </template>
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="$v.subscription.date_start.$model" :min="today" no-title @input="menuDateStart = false" type="date" :first-day-of-week="1" locale="es-cl" width="280" color="primary">
                    <div class="mx-auto">
                      <v-btn color="primary" @click="() => { $v.subscription.date_start.$model = today; menuDateStart = false }">Hoy</v-btn>
                      <v-btn class="ml-2" outlined @click="() => { $v.subscription.date_start.$model = ''; menuDateStart = false }">Limpiar</v-btn>
                    </div>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col md="2">
                <v-list-item-title class="ml-1 font-weight-medium">Término</v-list-item-title>
                <v-menu v-model="menuBillingCycles" :close-on-content-click="false" offset-y :nudge-bottom="10" transition="slide-y-transition" max-width="170">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-bind="attrs" v-on="on" background-color="white" dense height="36" hide-details outlined readonly single-line :value="subscription.billing_cycles ? `En ${subscription.billing_cycles} ciclos` : 'No definido'" />
                  </template>
                  <v-list>
                    <v-list-item class="pl-5" v-for="o in selectBillingCycles" :key="o.value">
                      <v-btn @click="subscription.billing_cycles=o.value" color="primary" :ripple="false" text>
                        <template v-if="o.value">En {{o.label}} ciclos</template>
                        <template v-else>{{o.label}}</template>
                      </v-btn>
                    </v-list-item>
                    <v-list-item style="max-width:100%">
                      <v-text-field v-model.number="subscription.billing_cycles" dense hide-details background-color="white" height="36" outlined prefix="En" required single-line suffix="ciclos" />
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
            <v-row class="py-2 pb-6">
              <v-list class="transparent">
                <v-list-item class="pl-7 mb-3">
                  <v-list-item-title>
                    Establecer fecha para la primera facturación
                    <v-tooltip right max-width="280px" transition="scale-transition">
                      <template v-slot:activator="{ on }">
                        <v-icon class="mt-n1" v-on="on" small color="secondary">mdi-information</v-icon>
                      </template>
                      <span>Establece una fecha para la primera facturación de la suscripción que sea distinta a la fecha de inicio.</span>
                    </v-tooltip>
                    <v-switch class="d-inline-block ml-6 mt-n2" v-model="setNextBilling" style="position:absolute;" />
                  </v-list-item-title>
                </v-list-item>
                <v-list-item class="pl-14 my-3" v-if="setNextBilling">
                  <v-list-item-title>Primera facturación</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-menu v-model="menuNextBilling" :close-on-content-click="false" offset-y :nudge-bottom="10" transition="slide-y-transition">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="$v.subscription.next_billing.$model" :error="$v.subscription.next_billing.$error" v-bind="attrs" v-on="on" background-color="white" height="36" outlined single-line dense readonly hide-details>
                          <template v-slot:append>
                            <v-icon class="mr-3" small color="secondary">mdi-calendar</v-icon>
                          </template>
                        </v-text-field>
                      </template>
                      <v-date-picker v-model="$v.subscription.next_billing.$model" :min="today" no-title @input="menuNextBilling = false" type="date" :first-day-of-week="1" locale="es-cl" width="280" color="primary">
                        <div class="mx-auto">
                          <v-btn color="primary" @click="() => { $v.subscription.next_billing.$model = today; menuNextBilling = false }">Hoy</v-btn>
                        </div>
                      </v-date-picker>
                    </v-menu>
                  </v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-row>
            <!-- end calendar -->

            <!-- invoicing -->
            <v-toolbar color="transparent" flat height="55">
              <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Facturación</v-toolbar-title>
            </v-toolbar>
            <v-divider/>
            <v-row class="py-2 pb-6">
              <v-col md="8">
                <v-list class="v-list-form v-sm-text-fields transparent">
                  <v-list-item>
                    <v-list-item-title>
                      Tipo de factura
                      <v-tooltip right max-width="280px" transition="scale-transition">
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                        </template>
                        <span>Es el tipo de factura que esta suscripción creará en cada ciclo de facturación. Debe ser compatible con la moneda del cliente.</span>
                      </v-tooltip>
                    </v-list-item-title>
                    <v-list-item-subtitle class="py-1">
                      <v-col cols="9">
                        <v-select v-model="$v.subscription.document.$model" :error="$v.subscription.document.$error" :items="selectDocuments" item-value="id" item-text="name" :menu-props="{ overflowY: true, transition: 'slide-y-transition' }" height="36" background-color="white" solo flat single-line outlined dense hide-details :ripple="false">
                          <template v-slot:item="data">
                            <v-list-item-title class="font-weight-regular">{{data.item.name}}</v-list-item-title>
                          </template>
                        </v-select>
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item>

                  <!-- CL invoice type tax settings fields -->
                  <template v-if="activeDocument.country === 'CL'">
                    <v-list-item>
                      <v-list-item-title>Forma de pago</v-list-item-title>
                      <v-list-item-subtitle class="py-1">
                        <v-col cols="9">
                          <v-select v-model="$v.subscription.tax_settings.cl_payment_type.$model" :error="$v.subscription.tax_settings.cl_payment_type.$error" :items="options.clPaymentTypes" item-value="id" item-text="name" :menu-props="{ overflowY: true, transition: 'slide-y-transition' }" height="36" background-color="white" solo flat single-line outlined dense hide-details :ripple="false">
                            <template v-slot:item="data">
                              <v-list-item-title class="font-weight-regular">{{data.item.name}}</v-list-item-title>
                            </template>
                          </v-select>
                        </v-col>
                      </v-list-item-subtitle>
                    </v-list-item>
                  </template>
                  <!-- end CL invoice type tax settings fields -->

                  <!-- MX invoice type tax settings fields -->
                  <template v-if="activeDocument.country === 'MX'">
                    <v-list-item>
                      <v-list-item-title>Uso del CFDI</v-list-item-title>
                      <v-list-item-subtitle class="py-1">
                        <v-col cols="9">
                          <v-select v-model="$v.subscription.tax_settings.mx_cfdi_use.$model" :error="$v.subscription.tax_settings.mx_cfdi_use.$error" :items="options.mxCfdiUses" item-value="id" item-text="name" :menu-props="{ overflowY: true, transition: 'slide-y-transition' }" height="36" background-color="white" solo flat single-line outlined dense hide-details :ripple="false">
                            <template v-slot:item="data">
                              <v-list-item-title class="font-weight-regular">{{data.item.name}}</v-list-item-title>
                            </template>
                          </v-select>
                        </v-col>
                      </v-list-item-subtitle>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-title>Forma de pago</v-list-item-title>
                      <v-list-item-subtitle class="py-1">
                        <v-col cols="9">
                          <v-select v-model="$v.subscription.tax_settings.mx_payment_form.$model" :error="$v.subscription.tax_settings.mx_payment_form.$error" :items="options.mxPaymentForms" item-value="id" item-text="name" :menu-props="{ overflowY: true, transition: 'slide-y-transition' }" height="36" background-color="white" solo flat single-line outlined dense hide-details :ripple="false">
                            <template v-slot:item="data">
                              <v-list-item-title class="font-weight-regular">{{data.item.name}}</v-list-item-title>
                            </template>
                          </v-select>
                        </v-col>
                      </v-list-item-subtitle>
                    </v-list-item>
                  </template>
                  <!-- end MX invoice type tax settings fields -->

                  <!-- generic-doc tax_percent field -->
                  <template v-if="activeDocument.has_local_format === false">
                    <v-list-item>
                      <v-list-item-title>Tasa de impuesto</v-list-item-title>
                      <v-list-item-subtitle class="py-1">
                        <v-col cols="3">
                          <v-text-field v-model.number="$v.subscription.tax_percent.$model" :error="$v.subscription.tax_percent.$error" background-color="white" dense height="36" hide-details max="100" min="0" outlined placeholder="0" reverse single-line>
                            <template v-slot:prepend-inner>%</template>
                          </v-text-field>
                        </v-col>
                      </v-list-item-subtitle>
                    </v-list-item>
                  </template>
                  <!-- end generic-doc tax_percent field -->

                  <v-list-item>
                    <v-list-item-title>
                      Días de vencimiento
                      <v-tooltip right max-width="280px" transition="scale-transition">
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                        </template>
                        <span>Días de vencimiento que tendrá la factura. Es útil cuando el cliente no tiene una tarjeta registrada o el cargo a la tarjeta falla.</span>
                      </v-tooltip>
                    </v-list-item-title>
                    <v-list-item-subtitle class="py-1">
                      <v-col cols="3">
                        <v-text-field v-model="subscription.expiration_days" background-color="white" dense height="36" hide-details outlined required reverse single-line />
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title>Comentario adicional</v-list-item-title>
                    <v-list-item-subtitle class="py-1">
                      <v-text-field v-model="$v.subscription.note.$model" :error="$v.subscription.note.$error" maxlength="100" background-color="white" height="36" outlined required single-line dense hide-details />
                    </v-list-item-subtitle>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
            <!-- end invoicing -->

            <!-- advanced options -->
            <v-toolbar color="transparent" flat height="55">
              <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Opciones avanzadas<v-chip class="ml-3" color="secondary" x-small>Opcional</v-chip></v-toolbar-title>
            </v-toolbar>
            <v-divider/>
            <v-row class="py-2">
              <v-col md="8">
                <v-list class="v-list-form v-sm-text-fields transparent">
                  <v-list-item>
                    <v-list-item-title>
                      Tipo de cambio personalizado
                      <v-tooltip right max-width="280px" transition="scale-transition">
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                        </template>
                        <span>Establece un valor fijo para la conversión de moneda o deja este campo en blanco para que Piriod determine automáticamente la conversión de moneda según el día en el cuál se esté facturando esta suscripción.</span>
                      </v-tooltip>
                    </v-list-item-title>
                    <v-list-item-subtitle class="py-1">
                      <v-col cols="8">
                        <v-text-field v-model="$v.subscription.custom_change.$model" :disabled="currency.id === activeCurrency.id" :error="$v.subscription.custom_change.$error" :prefix="`1 ${currency.id} es igual a`" :suffix="activeCurrency.id" background-color="white" outlined required single-line dense maxlength="60" persistent-hint hide-details />
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title class="pt-4 pb-2">
                      Requiere referencia
                      <v-tooltip right max-width="280px" transition="scale-transition">
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                        </template>
                        <span>La suscripción no se procesará si esta no tiene al menos una referencia.</span>
                      </v-tooltip>
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      <v-col cols="8">
                        <v-switch class="mt-n4" v-model="subscription.require_reference" style="position: absolute" />
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
            <v-row class="px-4" v-if="subscription.references.length">
              <v-col class="py-0" cols="3">
                <span class="body-2 text--secondary font-weight-medium">Documento</span>
              </v-col>
              <v-col class="py-0" cols="2">
                <span class="ml-1 body-2 text--secondary font-weight-medium">Fecha</span>
              </v-col>
              <v-col class="py-0" cols="4">
                <span class="ml-1 body-2 text--secondary font-weight-medium">Descripción</span>
              </v-col>
              <v-col class="py-0" cols="2">
                <span class="ml-1 body-2 text--secondary font-weight-medium">Vencimiento</span>
                <v-tooltip max-width="280px" transition="scale-transition" top>
                  <template v-slot:activator="{ on }">
                    <v-icon class="ml-1 mt-n1" v-on="on" small color="secondary">mdi-information</v-icon>
                  </template>
                  <span><v-chip color="secondary" x-small>Opcional</v-chip> Selecciona una fecha si necesitas que la suscripción se marque como <b>"Necesita atención"</b> en caso de que al menos una de las referencias esté vencida. La fecha de vencimiento siempre debe ser mayor a la fecha de la referencia.</span>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row class="px-3 v-sm-text-fields" v-for="(d, i) in subscription.references" :key="i">
              <v-col class="py-1" cols="3">
                <v-select v-model="$v.subscription.references.$each[i].document.$model" :error="$v.subscription.references.$each[i].document.$error" :items="options.clReferences" item-value="id" item-text="name" background-color="white" height="16" solo flat outlined single-line dense hide-details />
                <v-text-field v-model.trim="$v.subscription.references.$each[i].serial.$model" :error="$v.subscription.references.$each[i].serial.$error" prefix="ID / Nº" maxlength="18" background-color="white" height="16" outlined required single-line dense hide-details />
              </v-col>
              <v-col class="py-1" cols="2">
                <v-menu v-model="menuReferenceDate[i]" :close-on-content-click="false" offset-x id="date-picker">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field class="pa-0" v-model="$v.subscription.references.$each[i].date.$model" :error="$v.subscription.references.$each[i].date.$error" v-bind="attrs" v-on="on" background-color="white" height="16" outlined single-line dense readonly hide-details>
                      <template v-slot:append>
                        <v-icon class="mt-n1 mr-3" small color="secondary">mdi-calendar</v-icon>
                      </template>
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="$v.subscription.references.$each[i].date.$model" @input="menuReferenceDate[i]=false" type="date" locale="es-cl" width="280" color="primary" no-title :first-day-of-week="1">
                    <div class="mx-auto my-0">
                      <v-btn color="primary" @click="() => { $v.subscription.references.$each[i].date.$model = today; menuReferenceDate[i] = false }">Hoy</v-btn>
                      <v-btn class="ml-2" outlined @click="() => { d.date = ''; menuReferenceDate[i] = false }">Limpiar</v-btn>
                    </div>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col class="py-1" cols="4">
                <v-text-field v-model.trim="$v.subscription.references.$each[i].description.$model" :error="$v.subscription.references.$each[i].description.$error" maxlength="64" background-color="white" height="16" outlined required single-line dense hide-details />
              </v-col>
              <v-col class="py-1" cols="2">
                <v-menu v-model="menuReferenceDateEnd[i]" :close-on-content-click="false" offset-x id="date-picker">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field class="pa-0" v-model="$v.subscription.references.$each[i].date_end.$model" :error="$v.subscription.references.$each[i].date_end.$error" v-bind="attrs" v-on="on" background-color="white" height="16" outlined single-line dense readonly hide-details>
                      <template v-slot:append>
                        <v-icon class="mt-n1 mr-3" small color="secondary">mdi-calendar</v-icon>
                      </template>
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="$v.subscription.references.$each[i].date_end.$model" @input="menuReferenceDateEnd[i]=false" type="date" locale="es-cl" width="280" color="primary" no-title :first-day-of-week="1">
                    <div class="mx-auto my-0">
                      <v-btn color="primary" @click="() => { $v.subscription.references.$each[i].date_end.$model = today; menuReferenceDateEnd[i] = false }">Hoy</v-btn>
                      <v-btn class="ml-2" outlined @click="() => { d.date_end = null; menuReferenceDateEnd[i] = false }">Limpiar</v-btn>
                    </div>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col class="py-1" cols="1">
                <v-btn @click="subscription.references.splice(i, 1)" min-width="20" max-width="20" min-height="28" max-height="28" text color="red" :ripple="false"><v-icon size="20">mdi-delete</v-icon></v-btn>
              </v-col>
            </v-row>
            <v-row class="px-4 pb-6">
              <v-col>
                <v-btn @click="addReference" text color="primary" :ripple="false"><v-icon left>mdi-plus</v-icon>Agregar referencia</v-btn>
              </v-col>
            </v-row>
            <!-- end advanced options -->
          </template>
        </v-card-text>
        <v-divider/>
        <v-card-actions class="pa-4">
          <!-- fields errors message -->
          <span v-if="$v.subscription.$error">
            <v-icon color="red" left>mdi-alert</v-icon>
            <span class="body-1 red--text">
              <template v-if="!subscription.customer">Selecciona un cliente para continuar</template>
              <template v-else-if="!subscription.lines.length">Selecciona un producto para continuar</template>
              <template v-else>Corrige los campos marcados</template>
            </span>
          </span>
          <!-- end fields errors message -->

          <v-spacer />
          <v-btn @click="createSubscription" color="primary" :loading="$store.state.subscriptions.createLoader" :ripple="false">
            <template v-if="isFuture || isMetered">Programar suscripción</template>
            <template v-else>Crear suscripción</template>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>

    <!-- modal customer -->
    <v-dialog v-model="dialogCustomer" width="600" persistent scrollable no-click-animation>
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar flat height="55">
            <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Seleccionar un cliente</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="pr-1">
                <v-btn class="ml-3" @click="dialogCustomer=false" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-subtitle class="pa-0 background">
          <v-row align="center" justify="center" no-gutters>
            <v-col cols="12" class="px-3 py-1">
              <v-text-field v-model="customerQuery" background-color="white" outlined required single-line dense placeholder="Escribe para buscar un cliente..." hide-details/>
            </v-col>
          </v-row>
        </v-card-subtitle>
        <v-divider/>
        <v-card-text class="pa-0 background">
          <v-row align="center" justify="center" no-gutters>
            <v-col cols="12">
              <v-skeleton-loader v-if="$store.state.customers.retrieveLoader" transition="fade-transition" type="list-item"/>
              <template v-else>
                <template v-if="customersList.length">
                  <v-simple-table>
                    <template v-slot:default>
                      <tbody>
                        <tr v-for="d in customersList" :key="d.id" @click="setCustomer(d)" style="cursor: pointer">
                          <td>
                            <span class="d-block body-1 text--secondary font-weight-medium">{{d.name}}</span>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </template>
                <v-col v-else class="text-center py-5">
                  <v-icon color="secondary" size="70">mdi-close-circle</v-icon>
                  <span class="d-block subtitle-1">No existen clientes</span>
                </v-col>
              </template>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end modal customer -->

    <!-- modal products -->
    <v-dialog v-model="dialogProducts" width="600" persistent scrollable no-click-animation>
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar flat height="55">
            <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">
              <template v-if="productSelected.id">
                <a @click="productSelected={}">{{productSelected.name}}</a>
                <v-icon class="mx-1" color="secondary">mdi-chevron-right</v-icon>
                Seleccionar plan
              </template>
              <template v-else>Seleccionar un producto</template>
            </v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="pr-1">
                <v-btn class="ml-3" @click="dialogProducts=false" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-subtitle class="pa-0 background">
          <v-row align="center" justify="center" no-gutters>
            <template v-if="!productSelected.id">
              <v-col cols="12" class="px-3 py-1">
                <v-text-field background-color="white" outlined required single-line class="pa-0 mb-1" dense v-model="productQuery" placeholder="Escribe para buscar un producto..." hide-details/>
              </v-col>
              <v-col cols="12">
                <v-divider />
              </v-col>
            </template>
            <template v-if="currency">
              <v-col cols="12" class="px-4 py-1">
                <span class="d-block body-2 text--secondary">Sólo se muestran productos en moneda <b> {{currency.id}}</b></span>
              </v-col>
            </template>
          </v-row>
        </v-card-subtitle>
        <v-divider />
        <v-card-text class="pa-0 background">
          <v-row align="center" justify="center" no-gutters>
            <v-col cols="12" v-if="!productSelected.id">
              <v-skeleton-loader v-if="$store.state.subscriptions.retrieveLoader" transition="fade-transition" type="list-item"/>
              <template v-else>
                <template v-if="productsList.length">
                  <v-simple-table>
                    <template v-slot:default>
                      <tbody>
                        <tr v-for="d in productsList" :key="d.id" @click="productSelected=d" style="cursor: pointer">
                          <td>
                            <v-row class="py-3" align="center" justify="space-between" no-gutters>
                              <v-col cols="10">
                                <span class="d-block body-1 text--secondary font-weight-medium">{{d.name}}</span>
                                <span class="d-block">{{d.plans.length}} planes de precios</span>
                              </v-col>
                              <v-col cols="2" class="text-right">
                                <v-icon color="secondary">mdi-chevron-right</v-icon>
                              </v-col>
                            </v-row>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </template>
                <v-col class="text-center py-8" v-else>
                  <div class="text-center mb-4">
                    <v-icon size="70" color="secondary">mdi-cube-off</v-icon>
                  </div>
                  <span class="subtitle-1 text-center font-weight-regular">No existen productos</span>
                </v-col>
              </template>
            </v-col>
            <v-col cols="12" v-else>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    <tr v-for="d in productSelected.plans" :key="d.id" style="cursor: pointer">
                      <td v-if="(!currency || currency.id === d.currency.id) && (!frequency || frequency === d.frequency.id)" @click="setPlan(d)">
                        <v-row class="py-3" align="center" justify="space-between" no-gutters>
                          <v-col cols="9">
                            <span class="d-block body-1 text--secondary font-weight-medium">{{d.name}}</span>
                            <span>
                              <template v-if="d.tiers_mode">desde {{d.tiers[0].amount | currency(d.currency.id)}}</template>
                              <template v-else>{{d.amount | currency(d.currency.id)}}</template>
                              {{d.currency.id}} {{d.frequency.name.toLowerCase()}}
                            </span>
                          </v-col>
                          <v-col cols="3" class="text-right" v-if="checkPlanIsAdded(d.id)">
                            <v-chip color="defaultGrey" text-color="secondary" small>Añadido<v-icon class="ml-1" x-small>mdi-check</v-icon></v-chip>
                          </v-col>
                        </v-row>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end modal products -->

    <!-- modal addons -->
    <v-dialog v-model="modalAddons" width="600" persistent scrollable no-click-animation>
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar flat height="55">
            <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Seleccionar un complemento</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="pr-1">
                <v-btn class="ml-3" @click="modalAddons=false" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-subtitle class="pa-0 background">
          <v-row align="center" justify="center" no-gutters>
            <v-col cols="12" class="px-3 py-1">
              <v-text-field v-model="addonQuery" background-color="white" outlined required single-line dense  placeholder="Escribe para buscar un complemento..." hide-details/>
            </v-col>
            <v-col cols="12">
              <v-divider />
            </v-col>
            <template v-if="currency">
              <v-col cols="12" class="px-4 py-1">
                <span class="d-block body-2 text--secondary">Sólo se muestran complementos en moneda <b> {{currency.id}}</b></span>
              </v-col>
            </template>
          </v-row>
        </v-card-subtitle>
        <v-divider />
        <v-card-text class="pa-0 background">
          <v-row align="center" justify="center" no-gutters>
            <v-col cols="12">
              <v-skeleton-loader v-if="$store.state.subscriptions.retrieveLoader" transition="fade-transition" type="list-item"/>
              <template v-else>
                <template v-if="addonsList.length">
                  <v-simple-table>
                    <template v-slot:default>
                      <tbody>
                        <tr v-for="d in addonsList" :key="d.id" @click="setAddon(d)" :style="checkAddonIsAdded(d.id) ? '' : 'cursor: pointer'">
                          <td>
                            <v-row class="py-3" align="center" justify="space-between" no-gutters>
                              <v-col cols="9">
                                <span class="d-block body-1 text--secondary font-weight-medium">{{d.name}}</span>
                                <span class="mr-1">{{d.amount | number(d.currency.rounded)}} {{d.currency.id}} / {{d.apply_scheme === 'recurring' ? 'Recurrente' : 'Una vez'}}</span>
                                <span class="mx-1" v-if="d.apply_scheme === 'recurring'">válido por {{d.duration_times}} ciclos de facturación</span>
                              </v-col>
                              <v-col cols="3" class="text-right" v-if="checkAddonIsAdded(d.id)">
                                <v-chip color="defaultGrey" text-color="secondary" small>Añadido<v-icon class="ml-1" x-small>mdi-check</v-icon></v-chip>
                              </v-col>
                            </v-row>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </template>
                <v-col class="text-center py-8" v-else>
                  <div class="text-center mb-4">
                    <v-icon size="70" color="secondary">mdi-cube-off</v-icon>
                  </div>
                  <span class="subtitle-1 text-center font-weight-regular">No existen complementos</span>
                </v-col>
              </template>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end modal addons -->

    <!-- modal coupons -->
    <v-dialog v-model="modalCoupon" width="600" persistent scrollable no-click-animation>
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar flat height="55">
            <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Seleccionar un cupón</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="pr-1">
                <v-btn class="ml-3" @click="modalCoupon=false" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-subtitle class="pa-0 background">
          <v-row align="center" justify="center" no-gutters>
            <v-col cols="12" class="px-3 py-1">
              <v-text-field v-model="couponQuery" background-color="white" outlined required single-line dense maxlength="40" data-action="auto-focus" placeholder="Escribe para buscar un cupón..." hide-details/>
            </v-col>
            <v-col cols="12">
              <v-divider />
            </v-col>
            <template v-if="currency">
              <v-col cols="12" class="px-4 py-1">
                <span class="d-block body-2 text--secondary">Sólo se muestran descuentos en moneda <b> {{currency.id}}</b></span>
              </v-col>
            </template>
          </v-row>
        </v-card-subtitle>
        <v-divider />
        <v-card-text class="pa-0 background">
          <v-row align="center" justify="center" no-gutters>
            <v-col cols="12">
              <v-skeleton-loader v-if="$store.state.subscriptions.retrieveLoader" transition="fade-transition" type="list-item"/>
              <template v-else>
                <template v-if="couponsList.length">
                  <v-simple-table>
                    <template v-slot:default>
                      <tbody>
                        <tr v-for="d in couponsList" :key="d.id" @click="setCoupon(d)" style="cursor: pointer">
                          <td>
                            <v-row class="py-3" align="center" justify="space-between" no-gutters>
                              <v-col cols="12">
                                <span class="d-block body-1 text--secondary font-weight-medium">{{d.name}}</span>
                                <!-- coupons discount amount -->
                                <span v-if="d.discount_scheme === '%'" class="mr-1">{{d.amount | number(false)}} %</span>
                                <span v-else-if="d.discount_scheme === '$'" class="mr-1">{{d.amount | number(d.currency.rounded)}} {{d.currency.id}}</span>
                                <!-- end coupons discount amount -->

                                <!-- coupons discount duration -->
                                <span v-if="d.duration_scheme === 'one_time'" class="mr-1">por 1 ciclo de facturación</span>
                                <span v-else-if="d.duration_scheme === 'forever'" class="mr-1">por siempre</span>
                                <span v-else-if="d.duration_scheme === 'limited'" class="mr-1">por {{d.duration_times}} ciclos de facturación</span>
                                <!-- end coupons discount duration -->
                              </v-col>
                            </v-row>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </template>
                <v-col class="text-center py-8" v-else>
                  <div class="text-center mb-4">
                    <v-icon size="70" color="secondary">mdi-currency-usd-off</v-icon>
                  </div>
                  <span class="subtitle-1 text-center font-weight-regular">No existen descuentos</span>
                </v-col>
              </template>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end modal coupons -->
  </v-row>
</template>
<script>
import moment from 'moment'
import { mapState } from 'vuex'
import { decimal, required, requiredIf, integer, maxValue, minValue, maxLength, numeric } from 'vuelidate/lib/validators'
import { cloneDeep } from 'lodash'
import { clPaymentTypes, clReferences, mxCfdiUses, mxPaymentForms } from '@/collections/documents'

import GenericViewMixin from '@/mixins/GenericViewMixin'

import TierList from '@/components/subscription/TierList'
import CardBrand from '@/components/payments/CardBrand'

export default {
  mixins: [
    GenericViewMixin
  ],
  inject: ['theme'],
  components: {
    CardBrand,
    TierList,
    VBoilerplate: {
      functional: true,
      render (h, { data, props, children }) {
        return h('v-skeleton-loader', {
          ...data,
          props: {
            boilerplate: true,
            elevation: 2,
            ...props
          }
        }, children)
      }
    }
  },
  data: () => ({
    activeCustomer: {
      sources: []
    },
    addonQuery: '',
    couponLineSelected: null,
    couponQuery: '',
    couponTypeSelected: null,
    customerQuery: '',
    date: moment().format('YYYY-MM-DD'),
    dialogCustomer: false,
    dialogProducts: false,
    menuBillingCycles: false,
    menuDateStart: false,
    menuNextBilling: false,
    menuReferenceDate: [false],
    menuReferenceDateEnd: [false],
    modalAddons: false,
    modalCoupon: false,
    productQuery: '',
    productSelected: {},
    selectBillingCycles: [
      { value: null, label: 'No definido' },
      { value: 2, label: '2' },
      { value: 3, label: '3' },
      { value: 6, label: '6' },
      { value: 12, label: '12' }
    ],
    selectDocuments: [],
    setNextBilling: false,
    subscription: {
      addons: [],
      billing_cycles: null,
      collection_scheme: 'send_invoice',
      coupon: null,
      customer: null,
      custom_change: null,
      date_start: null,
      default_source: null,
      document: '',
      expiration_days: 30,
      lines: [],
      next_billing: null,
      note: '',
      references: [],
      tax_percent: null,
      tax_settings: {
        cl_payment_type: '2',
        mx_cfdi_use: '',
        mx_payment_form: ''
      }
    },
    options: {
      clPaymentTypes: clPaymentTypes,
      clReferences: clReferences,
      mxCfdiUses: mxCfdiUses,
      mxPaymentForms: mxPaymentForms
    }
  }),
  computed: {
    activeDocument () {
      return this.documents.find(d => d.id === this.subscription.document) || {}
    },
    activeCurrency () {
      return this.currencies.find(c => c.id === this.activeCustomer.currency) || {}
    },
    currency () {
      if (this.subscription.lines.length) {
        return this.subscription.lines[0].plan.currency
      }
      return null
    },
    frequency () {
      if (this.subscription.lines.length) {
        return this.subscription.lines[0].plan.frequency.id
      }
      return null
    },
    isFuture () {
      /**
       * determine if subscription is future
       * based on date_start or next_billing
       */
      if (this.subscription.date_start || this.subscription.next_billing) {
        const firstInvoice = this.subscription.next_billing || this.subscription.date_start

        return moment(firstInvoice).isAfter(moment())
      }
      return false
    },
    isMetered () {
      /**
       * determine if subscription is metered
       * based on lines plans
       */
      if (this.subscription.lines.length) {
        const meteredPlans = this.subscription.lines.filter(d => d.plan.usage_scheme === 'metered')

        if (meteredPlans.length) {
          return true
        }
      }

      return false
    },
    ...mapState({
      documents: state => state.generals.documentsList,
      customersList: state => state.customers.customersList,
      productsList: state => state.subscriptions.productsList,
      addonsList: state => state.subscriptions.addonsList,
      couponsList: state => state.subscriptions.couponsList,
      sourcesList: state => state.payments.sourcesList
    })
  },
  created () {
    this.$store.dispatch('generals/LIST', {
      resource: 'generals/documents',
      query: {
        country__id__in: `${this.account.country.id}, US`,
        is_sale: 'True'
      }
    })
    .then(() => {
      this.selectDocuments = []
      // generic documents
      const generics = this.documents.filter(d => d.country !== this.account.country.id)
      this.selectDocuments.push({ header: 'Genéricos' })
      this.selectDocuments = [...this.selectDocuments, ...generics]
      // local documents
      const sameCountry = this.documents.filter(d => d.country === this.account.country.id)
      if (sameCountry.length) {
        this.selectDocuments.push({ divider: true })
        this.selectDocuments.push({ header: this.account.country.name })
        this.selectDocuments = [...this.selectDocuments, ...sameCountry]
      }
    })
  },
  watch: {
    activeDocument (newer, older) {
      /**
       * Assign required tax settings fields accoring to document base country
       */
      if (newer.country && older.country && (newer.country !== older.country)) {
        // CL - assign specific tax settings
        if (newer.country === 'CL') {
          this.subscription.tax_settings.cl_payment_type = this.subscription.tax_settings.cl_payment_type || '2'
        }

        // MX - assign specific tax settings
        if (newer.country === 'MX') {
          this.subscription.tax_settings.mx_cfdi_use = this.subscription.tax_settings.mx_cfdi_use || 'G03'
          this.subscription.tax_settings.mx_payment_form = this.subscription.tax_settings.mx_payment_form || '99'
        }
      }

      // generic-doc tax flow only applies when has_local_format is explicitly
      // false; clear tax_percent otherwise so the API doesn't reject the payload.
      if (newer.has_local_format !== false) {
        this.subscription.tax_percent = null
      }
    },
    customerQuery () {
      this.debounceMethod(this.getCustomers)
    },
    productQuery () {
      this.debounceMethod(this.getProducts)
    },
    addonQuery () {
      this.debounceMethod(this.getAddons)
    },
    couponQuery () {
      this.debounceMethod(this.retrieveCoupons)
    },
    currency () {
      this.subscription.custom_change = null
    },
    dialogCustomer () {
      if (this.dialogCustomer) {
        this.getCustomers()
      }
    },
    dialogProducts () {
      if (this.dialogProducts) {
        this.getProducts()
      }
    },
    modalAddons () {
      if (this.modalAddons) {
        this.getAddons()
      }
    },
    modalCoupon () {
      if (this.modalCoupon) {
        this.retrieveCoupons()
      }
    }
  },
  methods: {
    createSubscription () {
      if (!this.subscription.billing_cycles) {
        this.subscription.billing_cycles = null
      }

      this.$v.subscription.$touch()

      if (this.$v.subscription.$invalid) {
        return false
      }

      const payload = cloneDeep(this.subscription)

      // tax_percent is only writable for non-electronic docs; strip otherwise.
      if (this.activeDocument.has_local_format !== false) {
        delete payload.tax_percent
      }

      payload.lines.forEach((d, i) => {
        payload.lines[i].plan = d.plan.id

        if (payload.lines[i].coupon) {
          payload.lines[i].coupon = d.coupon.id
        }
      })

      if (payload.addons.length) {
        payload.addons.forEach((d, i) => {
          payload.addons[i].addon = d.addon.id
        })
      }

      if (payload.coupon) {
        payload.coupon = payload.coupon.id
      }

      if (!this.setNextBilling) {
        delete payload.next_billing
      }

      this.$store.dispatch('subscriptions/CREATE', {
        resource: 'subscriptions',
        payload: payload
      })
      .then(response => {
        this.$dialog.message.info('La suscripción ha sido creada')
        this.$router.push({
          name: 'SubscriptionRetrieve',
          params: {
            id: response.data.id
          }
        })
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
    },
    getCustomers () {
      if ([1, 2].includes(this.customerQuery.length)) {
        return false
      }
      const query = {
        page_size: 10
      }
      if (this.customerQuery.length >= 3) {
        query.name__icontains = this.customerQuery.toLowerCase()
      }
      this.$store.dispatch('customers/LIST', {
        resource: 'customers',
        query: query
      })
    },
    setCustomer (customer) {
      /**
       * set customer to subscription
       * @param {Object} customer - customer object
       */
      this.activeCustomer = customer
      this.subscription.customer = customer.id
      this.customerQuery = ''
      this.dialogCustomer = false

      // list customer sources & resolve or set
      // collection_scheme & default_source
      // attributes
      this.getSources()

      // reset subscription fields validations
      this.$v.subscription.$reset()
    },
    getProducts () {
      if ([1, 2].includes(this.productQuery.length)) {
        return false
      }
      const query = {
        page_size: 10
      }
      if (this.productQuery.length >= 3) {
        query.name__icontains = this.productQuery.toLowerCase()
      }
      if (this.currency) {
        query.plans__currency = this.currency.id
      }
      if (this.frequency) {
        query.plans__frequency = this.frequency
      }
      this.$store.dispatch('subscriptions/LIST', {
        resource: 'products',
        query: query
      })
    },
    getAddons () {
      if ([1, 2].includes(this.addonQuery.length)) {
        return false
      }
      const query = {
        page_size: 10
      }
      if (this.addonQuery.length >= 3) {
        query.name__icontains = this.addonQuery.toLowerCase()
      }
      if (this.currency) {
        query.currency = this.currency.id
      }
      this.$store.dispatch('subscriptions/LIST', {
        resource: 'addons',
        query: query
      })
    },
    setAddon (addon) {
      if (this.checkAddonIsAdded(addon.id)) {
        return false
      }
      this.subscription.addons.push({
        addon: addon,
        quantity: 1,
        rates: []
      })
      this.addonQuery = ''
      this.modalAddons = false
    },
    setAddonLineRate (i) {
      this.subscription.addons[i].rates = [
        { billing_cycle: '', percentage: null, description: '' },
        { billing_cycle: '', percentage: null, description: '' }
      ]
    },
    addAddonLineRate (i) {
      this.subscription.addons[i].rates.push({
        billing_cycle: '',
        percentage: null,
        description: ''
      })
    },
    setPlan (plan) {
      /**
       * set plan to subscription
       * @param {Object} plan - plan object
       */
      if (this.checkPlanIsAdded(plan.id)) {
        return false
      }

      this.subscription.lines.push({
        plan: plan,
        quantity: 1,
        coupon: null,
        rates: []
      })

      this.productQuery = ''
      this.productSelected = {}
      this.dialogProducts = false

      // reset subscription fields validations
      this.$v.subscription.$reset()
    },
    setPlanDiscountEnd () {
      return false
    },
    checkPlanIsAdded (id) {
      const plan = this.subscription.lines.filter(p => p.plan.id === id)
      if (plan.length) {
        return true
      }
      return false
    },
    checkAddonIsAdded (id) {
      const addon = this.subscription.addons.filter(p => p.addon.id === id)
      if (addon.length) {
        return true
      }
      return false
    },
    showModalCoupon (type, line = null) {
      this.couponTypeSelected = type
      this.couponLineSelected = line
      this.modalCoupon = true
      this.retrieveCoupons()
    },
    retrieveCoupons () {
      if ([1, 2].includes(this.couponQuery.length)) {
        return false
      }
      const query = {
        page_size: 10,
        apply_on: this.couponTypeSelected
      }
      if (this.couponQuery.length >= 3) {
        query.name__icontains = this.couponQuery.toLowerCase()
      }
      if (this.currency) {
        query.currency = this.currency.id
      }
      this.$store.dispatch('subscriptions/LIST', {
        resource: 'coupons',
        query: query
      })
    },
    setCoupon (coupon) {
      if (this.couponTypeSelected === 'line') {
        this.subscription.lines[this.couponLineSelected].coupon = coupon
      }
      if (this.couponTypeSelected === 'invoice') {
        this.subscription.coupon = coupon
      }
      this.couponQuery = ''
      this.modalCoupon = false
    },
    addReference () {
      this.subscription.references.push({
        date: null,
        date_end: null,
        description: '',
        document: '',
        serial: ''
      })
    },
    getSources () {
      const query = {
        customer: this.activeCustomer.id,
        gateway__currencies__in: this.activeCustomer.currency,
        status: 'chargeable',
        usage: 'reusable'
      }

      this.$store.dispatch('payments/LIST', {
        resource: 'sources',
        query: query
      })
      .then(() => {
        // set default source or reset & set collection_scheme
        if (this.sourcesList.length) {
          const source = this.sourcesList[0]
          this.subscription.default_source = source.id
          this.subscription.collection_scheme = 'charge_payment'
        } else {
          this.subscription.default_source = null
          this.subscription.collection_scheme = 'send_invoice'
        }
      })
    }
  },
  validations: {
    subscription: {
      customer: {
        required
      },
      custom_change: {
        decimal
      },
      document: {
        required,
        currencyIsValid: function () {
          if (!this.subscription.customer) {
            return true
          }
          const currencies = this.activeDocument.currencies || []
          if (currencies.length) {
            return currencies.includes(this.activeCustomer.currency)
          }
          return false
        }
      },
      lines: {
        $each: {
          quantity: {
            required
          }
        }
      },
      addons: {
        $each: {
          quantity: {
            required,
            numeric
          },
          rates: {
            $each: {
              billing_cycle: {
                required,
                numeric,
                repetitions: function () {
                  return true
                }
              },
              percentage: {
                required,
                integer,
                maxValue: maxValue(100)
              },
              description: {
                maxLength: maxLength(40)
              }
            }
          }
        }
      },
      date_start: {
        required
      },
      billing_cycles: {
        numeric
      },
      expiration_days: {
        numeric
      },
      next_billing: {
        required: requiredIf(function () {
          return this.setNextBilling
        }),
        minDate: function () {
          if (!this.setNextBilling) {
            return true
          }

          if (this.subscription.next_billing) {
            return moment(this.subscription.next_billing).isSameOrAfter(this.subscription.date_start)
          }
          return true
        }
      },
      note: {
        maxLength: maxLength(100)
      },
      references: {
        $each: {
          date: {
            required
          },
          date_end: {
            minDate: (value, obj) => {
              if (value) {
                return moment(value).isAfter(obj.date)
              }
              return true
            }
          },
          description: {
            maxLength: maxLength(64)
          },
          document: {
            required
          },
          serial: {
            required,
            maxLength: maxLength(18)
          }
        }
      },
      tax_percent: {
        decimal,
        minValue: minValue(0),
        maxValue: maxValue(100)
      },
      tax_settings: {
        cl_payment_type: {
          required: requiredIf(function () {
            return this.activeDocument.country === 'CL'
          }),
          maxLength: maxLength(1)
        },
        mx_cfdi_use: {
          required: requiredIf(function () {
            return this.activeDocument.country === 'MX'
          }),
          maxLength: maxLength(3)
        },
        mx_payment_form: {
          required: requiredIf(function () {
            return this.activeDocument.country === 'MX'
          }),
          maxLength: maxLength(2)
        }
      }
    }
  }
}
</script>